var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "order-btn" },
        [
          _c(
            "vxe-button",
            {
              on: {
                click: function ($event) {
                  return _vm.returnFun()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _vm.approveBtnType === "3"
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(5)
                    },
                  },
                },
                [_vm._v("重新发起审批")]
              )
            : _vm._e(),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(1)
                    },
                  },
                },
                [_vm._v("同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(2)
                    },
                  },
                },
                [_vm._v("退回上一审批人")]
              )
            : _vm._e(),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(3)
                    },
                  },
                },
                [_vm._v("驳回")]
              )
            : _vm._e(),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(6)
                    },
                  },
                },
                [_vm._v("不同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(4)
                    },
                  },
                },
                [_vm._v("转派")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("a-divider"),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("订单信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form",
            {
              ref: "orderForm",
              staticClass: "UniformCss",
              attrs: { inline: true, model: _vm.order, "label-width": "100px" },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: "订单编号", prop: "applyOrderCode" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyOrderCode", $$v)
                              },
                              expression: "order.applyOrderCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领部门", prop: "orgName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orgName", $$v)
                              },
                              expression: "order.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领人", prop: "applyMan" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyMan", $$v)
                              },
                              expression: "order.applyMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领日期", prop: "applyTime" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyTime", $$v)
                              },
                              expression: "order.applyTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "订单总项数",
                            prop: "orderMaterialCount",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderMaterialCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderMaterialCount", $$v)
                              },
                              expression: "order.orderMaterialCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "订单总数量", prop: "orderNums" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderNums", $$v)
                              },
                              expression: "order.orderNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "订单总金额",
                            prop: "orderTotalSums",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderTotalSums", $$v)
                              },
                              expression: "order.orderTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "审批数量", prop: "approveNums" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.approveNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveNums", $$v)
                              },
                              expression: "order.approveNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "审批总金额",
                            prop: "approveTotalSums",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.approveTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "approveTotalSums", $$v)
                              },
                              expression: "order.approveTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "收货人", prop: "receiverName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.receiverName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receiverName", $$v)
                              },
                              expression: "order.receiverName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "收货联系方式",
                            prop: "receivePhone",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.receivePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receivePhone", $$v)
                              },
                              expression: "order.receivePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "详细地址" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.order.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "address", $$v)
                              },
                              expression: "order.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("物料信息")]),
      _c(
        "div",
        [
          _c(
            "vxe-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.materialList,
                "show-header-overflow": "",
                "show-overflow": "",
                border: "",
                "header-cell-style": { background: "#eef1f6" },
              },
            },
            [
              _vm.order.orderStatus == "1"
                ? _c("vxe-table-column", {
                    attrs: {
                      title: "操作",
                      width: "100",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "a-button",
                                {
                                  attrs: { primary: "", type: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editFun("", row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2283930118
                    ),
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: {
                  field: "materialCode",
                  title: "物料号",
                  width: "150",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "materialName",
                  title: "物料名称",
                  width: "250",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "storage",
                  title: "数量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "price",
                  title: "申领价",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "nums",
                  title: "申领数量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "totalSums",
                  title: "申领总金额",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "approveNums",
                  title: "审批数量",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "approveTotalSums",
                  title: "审批总金额",
                  width: "90",
                  align: "center",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "applyRemarks",
                  title: "申领备注",
                  width: "160",
                  resizable: false,
                  "show-overflow": "",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _c("ApproveMaterialDialog", {
            attrs: {
              visible: _vm.dialogVisible,
              orderMaterial: _vm.rowMaterial,
              pictures: _vm.picList,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              "update:orderMaterial": function ($event) {
                _vm.rowMaterial = $event
              },
              "update:order-material": function ($event) {
                _vm.rowMaterial = $event
              },
              saveMaterial: _vm.saveMaterial,
              cancel: _vm.cancel,
              close: _vm.close,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              staticStyle: { "margin-bottom": "10px" },
              model: {
                value: _vm.collapseNumber,
                callback: function ($$v) {
                  _vm.collapseNumber = $$v
                },
                expression: "collapseNumber",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  staticClass: "collapseItem",
                  attrs: { title: "提报审核历史", name: "default" },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.findHistTasksData,
                        loading: _vm.approveLoading,
                        border: "",
                        stripe: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "displayName", label: "审核部门" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operatorName", label: "审核人" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "finishTime", label: "审核时间" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amounts",
                          label: "申请费用(元)",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.amounts
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toThousandNumFilter")(
                                              row.amounts
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "approveCost",
                          label: "审核费用(元)",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.approveCost
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toThousandNumFilter")(
                                              row.approveCost
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operateType", label: "操作类型" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "approveMsg", label: "审核意见" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.approveDialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialogVisible = $event
            },
          },
        },
        [
          _vm.approveTypeName === "转 派"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 转派人： "),
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    attrs: { placeholder: "请选择转派的用户" },
                    on: { focus: _vm.chooseUser },
                    model: {
                      value: _vm.operatorUser,
                      callback: function ($$v) {
                        _vm.operatorUser = $$v
                      },
                      expression: "operatorUser",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.approveTypeName === "同 意" && _vm.order.isDealer != "1"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _vm._v(" 年度申领额度（元）： "),
                      _c("a-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.order.yearApplyQuota || 0,
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _vm._v(" 年度累计申领金额（元）： "),
                      _c("a-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.order.yearTotalAmount || 0,
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            on: { input: _vm.gettotalCost },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _vm.approveValFalse
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("审批意见不能为空"),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { loading: _vm.approveBtnLoading, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approve()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.approveTypeName))]
              ),
              _c("vxe-button", { on: { click: _vm.cancelDialogVisible } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.userDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入用户名称", clearable: "" },
                on: { change: _vm.handleFilter },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xuser",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.userLoading,
                "max-height": "350",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.userLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { visible: false, field: "id", title: "用户id" },
              }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "用户名称", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "department", title: "所属组织结构" },
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.userLoading,
              "current-page": _vm.addTablePage.currentPage,
              "page-size": _vm.addTablePage.pageSize,
              total: _vm.addTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChooseUser()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }